import React, { useEffect, useRef } from 'react';
import { browserHistory } from 'react-router';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { CheckoutProductCard } from '../checkout-product-card';
import classes from './checkout-products-list.scss';
const MAX_LIST_WRAPPER_HEIGHT = 725;
const TOTAL_SECTION_HEIGHT = 90;
export const CheckoutProductsListComponent = ({
  products,
  itemsNumber,
  total,
  link,
  giveawayType,
  onDeleteProduct,
  numbersColor,
  onQuantityChange
}) => {
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  useEffect(() => {
    if (link && !products.length) {
      browserHistory.push(GiveawayUrl.getGiveawayUserLanding({
        link,
        giveawayType
      }));
    }
  }, [products, link]);
  useEffect(() => {
    if (isMobile()) {
      return;
    }
    if (wrapperRef !== null && wrapperRef !== void 0 && wrapperRef.current && listRef !== null && listRef !== void 0 && listRef.current) {
      var _listRef$current;
      const listHeight = (listRef === null || listRef === void 0 ? void 0 : (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.offsetHeight) || 0;
      const wrapperHeight = listHeight < MAX_LIST_WRAPPER_HEIGHT ? listHeight + TOTAL_SECTION_HEIGHT : MAX_LIST_WRAPPER_HEIGHT;
      wrapperRef.current.style.height = `${wrapperHeight}px`;
    }
  }, [wrapperRef, listRef, products]);
  const handleRemoveClick = product => {
    onDeleteProduct(product, link);
  };
  const handleQuantityChange = (productId, quantity) => {
    if (onQuantityChange && link) {
      onQuantityChange(productId, quantity, link);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.listWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.list,
    ref: listRef
  }, products.map(product => /*#__PURE__*/React.createElement(CheckoutProductCard, {
    key: product._id,
    product: product,
    showDeleteButton: products.length > 1,
    onDeleteProduct: handleRemoveClick,
    onChangeQuantity: handleQuantityChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.emptyElement
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.totalWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.totalContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.total
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: classes.totalLabel
  }, "Number of items:"), /*#__PURE__*/React.createElement("p", {
    className: classes.totalValue,
    style: {
      color: numbersColor
    }
  }, itemsNumber)), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.subTotalWrapper
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.totalLabel
  }, "Sub total: "), /*#__PURE__*/React.createElement("p", {
    className: classes.totalValue,
    style: {
      color: numbersColor
    }
  }, total))))));
};